import React, { Fragment } from 'react'
import { Modal, Button } from 'react-bootstrap'
import OrderDetail from '../Order/OrderDetail'

const ModalOrderDetail = (props) => {
  const { orders, showModalOrderDetail, setShowModalOrderDetail } = props
  return (
    <Fragment>
      <Modal show={showModalOrderDetail} size="xl">
        <Modal.Header>
          คำสั่งซื้อ:#
          <Button
            variant=""
            onClick={() => {
              setShowModalOrderDetail(false)
            }}
          >
            <span>&times;</span>
          </Button>
        </Modal.Header>
        <Modal.Body>
          <OrderDetail
            order={orders}
            onOk={() => setShowModalOrderDetail(false)}
            onCancel={() => setShowModalOrderDetail(false)}
            onIssue={() => setShowModalOrderDetail(false)}
          />
        </Modal.Body>
      </Modal>
    </Fragment>
  )
}

export default ModalOrderDetail
